import { Page } from '@/core/architecture'

import { FirstComeFirstServedConfirmationTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * FirstComeFirstServedConfirmation Page
 * Implemented as a practical sample.
 */
export const FirstComeFirstServedConfirmation: Page = () => {
  const { state, actions } = useViewModel()

  return <FirstComeFirstServedConfirmationTemplate state={state} {...actions} />
}
